module.exports = __webpack_public_path__ + "img/comment.16b5a932.svg";